import React, { useEffect } from 'react'
import { connect } from 'react-redux'
import { createStructuredSelector } from 'reselect'
import { ToastContainer, toast } from 'react-toastify'

import './Toaster.css'
import { toasterSelector } from '../selectors/toasterSelectors'
import * as toasterActions from '../actions/toasterActions'
import Toast from './Toast'

const Toaster = ({ toaster, clearToast, toastShown }) => {
  useEffect(() => {
    toaster.forEach((toastId) => toast(<Toast id={toastId} />, { toastId, onClose: clearToast, onOpen: toastShown }))
  }, [clearToast, toastShown, toaster])

  return <ToastContainer hideProgressBar draggable={false} closeButton={false} autoClose={false} />
}

const mapStateToProps = createStructuredSelector({
  toaster: toasterSelector,
})

const mapDispatchToProps = {
  clearToast: toasterActions.clearToast,
  toastShown: toasterActions.toastShown,
}

export default connect(mapStateToProps, mapDispatchToProps)(Toaster)
